import React, { useState, useContext, useEffect } from "react";
import styled from "styled-components";
import { Grid } from "@mui/material";
import SidePanelCards from "./elements/SidePanelCards";
import LocationSelect from "./elements/LocationSelect";
import PanelTools from "./elements/PanelTools";
import { WebMapContext } from "../pages/sections/web-map/WebMapGoogleMap";
import { LoadMapContext } from "../pages/sections/web-map/LoadWebMap";
import { MapTools } from "../constants/WebMap";
import SidePanelHead from "./elements/SidePanelHead";

const SidePanelMainWrapper = styled.div`
  color: black !important;
  font-weight: bold;
`;

export default function SidePanel({ setPosition }) {
  const { mapPlacement, selectedCountryPremissions } = useContext(WebMapContext);
  const { mapView, commonFilters, setSidePanelWidth, setShowMsModal, collapseSideBar, setShowIbsTable } = useContext(LoadMapContext);

  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);
  const [openedTabs, setOpenedTabs] = useState({
    isAdminLevelCardOpen: false,
    isSidePanelCardOpen: false,
  });
  const [isEyeIconVisibleAsGreen, setIsEyeIconVisibleAsGreen] = useState(false);
  const [isEyeIconVisibleAsGreenForSites, setIsEyeIconVisibleAsGreenForSites] =
    useState(false);

  useEffect(() => {
    setIsCollapsed(mapView === null ? false : true);
    setIsSidePanelOpen(mapView === null ? isSidePanelOpen : false);
  }, [mapView]);

  useEffect(() => {
    commonFilters.country && setIsSidePanelOpen(!isCollapsed);
    if (!isCollapsed && mapView !== null) { 
      mapPlacement === "right" ? setShowMsModal({rightModal: true, leftModal: false }) : setShowMsModal({rightModal: false, leftModal: true });
      if (mapPlacement === "right") {
        setShowMsModal({rightModal: true, leftModal: false });
        setShowIbsTable({rightTable: true,  leftTable: false});
      } else {
        setShowMsModal({rightModal: false, leftModal: true });
        setShowIbsTable({rightTable: false,  leftTable: true});
      }
    }
  }, [isCollapsed]);

  useEffect(() => {
    const element = document.getElementsByClassName("web-map-side-panel");
    setSidePanelWidth(mapPlacement === "left" ? element[0].offsetWidth : element[1].offsetWidth);
  }, [isSidePanelOpen]);

  useEffect(() => {
    if (mapView !== null) {
      setIsCollapsed(mapPlacement === "left" ? collapseSideBar.leftSideBar : collapseSideBar.rightSideBar);
    }
  }, [collapseSideBar]);

  return (
    <SidePanelMainWrapper>
      <Grid
        container
        md={isCollapsed
          ? mapView === MapTools.SPLIT
            ? 1.1
            : 0.57
          : mapView === MapTools.SPLIT ? 5.8 : 2.9}
        spacing={0}
        className="web-map-side-panel"
        style={{
          position: "absolute",
          top: "8px",
          ...(mapPlacement === 'right'
            ? { right: '8px' }
            : { left: '8px' }),
          overflow: "auto",
          maxHeight: "85vh",
          width: "auto",
          zIndex: 2
        }}
      >
        <Grid
          container
          xs={2.5}
          sm={2.5}
          md={12}
          style={{
            backgroundColor: "white",
            borderRadius: "7px",
            maxWidth: "320px",
            ...(!isCollapsed && { paddingBottom: "10px" })
          }}
        >
          <Grid
            container
            item
            style={{
              backgroundColor: "white",
              borderRadius: "5px",
              position: "sticky",
              top: 0,
              zIndex: 1,
              // boxShadow: '0px 1px 4px #00000026'
            }}
          >
            <SidePanelHead
              handleCollapsed={setIsCollapsed}
              isCollapsed={isCollapsed}
              isOpen={setIsSidePanelOpen}
            />
          </Grid>
          <Grid
            container
            item
            style={{
              display: !isCollapsed && isSidePanelOpen ? "block" : "none"
            }}
          >
            <LocationSelect
              openedTabs={openedTabs}
              setOpenedTabs={setOpenedTabs}
              isEyeIconVisibleAsGreen={isEyeIconVisibleAsGreen}
              setIsEyeIconVisibleAsGreen={setIsEyeIconVisibleAsGreen}
              setPosition={setPosition}
              setIsEyeIconVisibleAsGreenForSites={
                setIsEyeIconVisibleAsGreenForSites
              }
              selectedCountryPrems={selectedCountryPremissions?.find((p) => p.name === "Geographical Area")}
            />
          </Grid>
          <Grid container item
            style={{
              display: isCollapsed ? "none" : "block"
            }}>
            <SidePanelCards
              isEyeIconVisibleAsGreen={isEyeIconVisibleAsGreen}
              show={isSidePanelOpen}
              openedTabs={openedTabs}
              setOpenedTabs={setOpenedTabs}
              isEyeIconVisibleAsGreenForSites={isEyeIconVisibleAsGreenForSites}
              selectedCountryPrems={selectedCountryPremissions}
            />
          </Grid>
        </Grid>
      </Grid>
    </SidePanelMainWrapper>
  );
}
